import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isShow = new BehaviorSubject<boolean>(false);
  // Tracks request-owned loading so parallel responses cannot hide the overlay early.
  private activeLoadingOperations = 0;
  // Preserves compatibility with existing screens that control visibility directly.
  private isManualLoaderVisible = false;

  @Output() showPopUp: EventEmitter<boolean> = new EventEmitter();

  toggleLoader(newState: boolean) {
    this.isManualLoaderVisible = newState;
    this.updateLoaderVisibility();
  }

  changeLoaderState(value: boolean) {
    setTimeout(() => {
      this.toggleLoader(value);
    });
  }

  // Stops the current loader display before a blocking regular popup takes over.
  hideLoader(): void {
    this.activeLoadingOperations = 0;
    this.isManualLoaderVisible = false;
    this.updateLoaderVisibility();
  }

  // Returns an idempotent completion callback for a single async operation.
  beginLoading(): () => void {
    this.activeLoadingOperations++;
    this.updateLoaderVisibility();

    let isCompleted = false;
    return () => {
      if (isCompleted) {
        return;
      }

      isCompleted = true;
      this.activeLoadingOperations = Math.max(0, this.activeLoadingOperations - 1);
      this.updateLoaderVisibility();
    };
  }

  getState(): boolean {
    return this.isShow.getValue();
  }

  getStateObs(): Observable<boolean> {
    return this.isShow.asObservable();
  }

  // Combines legacy manual visibility with tracked request activity.
  private updateLoaderVisibility(): void {
    const isVisible = this.isManualLoaderVisible || this.activeLoadingOperations > 0;
    if (isVisible !== this.isShow.getValue()) {
      this.isShow.next(isVisible);
    }
  }
}
